import { DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S8};
`

export const SearchWrapper = styled.div`
  width: 100%;
`

export const AccountList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S2};
  max-height: 45vh;
  overflow-y: auto;
`

export const AccountSkeletonRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  width: 100%;
  padding: ${Spacing.S12};
  border-radius: ${DefaultValue.BorderRadius};
`

export const AccountSkeletonLabel = styled.div`
  flex: 1;
`

export const EmptyState = styled.div`
  padding: ${Spacing.S8} 0;
`
